import { createReducer } from '@reduxjs/toolkit'
import { setIsVisible, setSelectedVideo, setVideoPlayer } from './modal-player.actions'
import { Video } from '../../../models/interfaces/video.interface'

interface PlayerState {
  video: Video | null
  selectedVideo: string | null
  isVisible: boolean
}

const initialState: PlayerState = {
  video: null,
  selectedVideo: null,
  isVisible: false
}

export const modalPlayerReducer = createReducer(initialState, builder => {
  builder.addCase(setSelectedVideo, (state, action) => ({
    ...state,
    video: action.payload
  }))
  builder.addCase(setIsVisible, (state, action) => ({
    ...state,
    isVisible: action.payload
  }))
  builder.addCase(setVideoPlayer, (state, action) => ({
    ...state,
    video: action.payload.video,
    isVisible: action.payload.isVisible ? action.payload.isVisible : false
  }))
})
